// 型＆ローダ（TSのみ）
export interface AppConfig {
  COGNITO_REGION: string;
  COGNITO_DOMAIN_PREFIX: string;
  COGNITO_CLIENT_ID: string;
  REDIRECT_URI: string;
  LOGOUT_URI: string;
}

declare global {
  interface Window { __APP_CONFIG__?: AppConfig }
}

/** 初回だけ /env.json を取得して window に注入 */
export async function loadAppConfig(): Promise<AppConfig> {
  if (window.__APP_CONFIG__) return window.__APP_CONFIG__;
  const res = await fetch('/env.json', { cache: 'no-store' });
  if (!res.ok) throw new Error('env.json not found');
  const cfg = (await res.json()) as AppConfig;
  window.__APP_CONFIG__ = cfg;
  return cfg;
}

/** どこからでも設定を取り出す */
export function getAppConfig(): AppConfig {
  const cfg = window.__APP_CONFIG__;
  if (!cfg) throw new Error('AppConfig not loaded. Call loadAppConfig() first.');
  return cfg;
}
